import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { Body, Label } from '~/components/typography/Content'
import { Input } from '~/components/ui/input'
import { cn } from '~/lib/utils'

type OrganisationFormFieldsProps = {
  name: string
  onNameChange: (name: string) => void
  emailDomain?: string
  onEmailDomainChange?: (domain: string) => void
  showDomainField?: boolean
}

export function OrganisationFormFields({
  name,
  onNameChange,
  emailDomain,
  onEmailDomainChange,
  showDomainField = true,
}: OrganisationFormFieldsProps) {
  const { t } = useTranslations('admin')

  return (
    <View className="gap-6">
      <View className="gap-2">
        <Label>{t(($) => $.organisations.create.nameLabel)}</Label>
        <Input
          value={name}
          onChangeText={onNameChange}
          placeholder={t(($) => $.organisations.create.namePlaceholder)}
          variant="box"
          className={cn('bg-white', !name.trim() && 'border-destructive/70')}
        />
      </View>

      {showDomainField && (
        <View className="gap-2">
          <Label>{t(($) => $.organisations.create.emailDomainLabel)}</Label>
          <Body className="text-sm text-secondary">
            {t(($) => $.organisations.create.emailDomainDescription)}
          </Body>
          <Input
            value={emailDomain || ''}
            onChangeText={(text) => onEmailDomainChange?.(text.toLowerCase().trim())}
            placeholder={t(($) => $.organisations.create.emailDomainPlaceholder)}
            variant="box"
            autoCapitalize="none"
            autoCorrect={false}
            className={cn('bg-white', !emailDomain?.trim() && 'border-destructive/70')}
          />
        </View>
      )}

      {!showDomainField && emailDomain && (
        <View className="gap-2">
          <Label>{t(($) => $.organisations.create.emailDomainLabel)}</Label>
          <Body className="text-sm text-secondary">{emailDomain}</Body>
        </View>
      )}
    </View>
  )
}
